import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  UncontrolledTooltip,
} from "reactstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import getAccessRights from "components/Common/getAccessRights";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "components/Common/custom-select";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchTaskTypeMode, changeTaskTypeStatus, fetchTaskType, saveTaskType } from "store/actions";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import useButtonAccess from "components/Common/useButtonAccess";

const TaskTypeTask = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);

  const { 
      taskType,
      typeMode,
      loading,
      success,
      error, 
  } = useSelector((state) => ({
      taskType : state.TimesheetSetupTaskTypeReducer?.taskType  ?? [],
      typeMode : state.TimesheetSetupTaskTypeReducer?.typeMode  ?? [],           
      loading: state.TimesheetSetupTaskTypeReducer?.loading,
      error: state.TimesheetSetupTaskTypeReducer?.error,
      success: state.TimesheetSetupTaskTypeReducer?.success,
  }));

  useEffect(() => {
      resetFormData();
      const authUserDetails = useAuthUserDetails();
      setAuthDetails(authUserDetails[0])
      const unitId = authUserDetails[0].unit_id     
      
      const formData = new FormData();
      formData.append("unit_id", unitId); 
      dispatch(fetchTaskTypeMode(formData));           
      dispatch(fetchTaskType(unitId));        
  }, [dispatch]); 

  useEffect(() => {
      if(success){
          dispatch(fetchTaskType(authDetails?.unit_id));          
          formik.resetForm();
          setIsEdit(false);
          setEditId(null);
          resetFormData();
      }
  }, [authDetails,success,dispatch]);
  
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [modeData,setModeData] = useState(null);

  useEffect(() => {
    const accessRight = getAccessRights(location.pathname,history);
  }, [location]);

  const formik = useFormik({
    initialValues: {
      mode: "",
      task_type: "",
    },
    validationSchema: Yup.object({
      mode: Yup.object().nullable().typeError("Mode is required").required("Mode is required"),
      task_type: Yup.string()
        .required("Tasktype is required")
        .max(50, "Tasktype must be at most 50 characters"),
    }),
    onSubmit: (values, { resetForm }) => {    
      const formData = new FormData();
      formData.append("tasktype_id", editId ? editId : 0);
      formData.append("proj_mode", values.mode.value);
      formData.append("task_type", values.task_type);
      formData.append("create_by", authDetails?.user_id);
      formData.append("unit_id", authDetails?.unit_id);
      dispatch(saveTaskType(formData));  
      resetFormData(); 
    },
  });

  const handleEdit = (row) => {
    setIsEdit(true);
    setEditId(row.task_type_id);
    formik.setValues({
        mode: {value:row.pmode_id,label:row.pmode},       
        task_type: row.task_type,
    });      
    setModeData({value:row.pmode_id,label:row.pmode});
    formik.setFieldValue("mode", {value:row.pmode_id,label:row.pmode});       
  };

  const handleToggleStatus = (id,isActive) => {
    Swal.fire({
        title: 'Are you sure?',
        text: `You are about to ${isActive ? 'deactivate' : 'activate'} this task type.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        reverseButtons: false,
        dangerMode: true,
    }).then((result) => {
        if (result.isConfirmed) {
          const formData = new FormData();
          formData.append("tasktype_id", id);
          formData.append("create_by", authDetails?.user_id);            
          formData.append("unit_id", authDetails?.unit_id);
          dispatch(changeTaskTypeStatus(formData));
        }       
    });
  };

  const CustomSelect = ({
      closeMenuOnScroll = true,
      menuPortalTarget = document.body,
      menuPosition = "fixed",
      menuShouldScrollIntoView = false,
      ...props
    }) => {
      return (
        <Select
          {...props}
          closeMenuOnScroll={closeMenuOnScroll}
          menuPortalTarget={menuPortalTarget}
          menuPosition={menuPosition}
          menuShouldScrollIntoView={menuShouldScrollIntoView}
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
        />
      );
    };

  const resetFormData = () => {
    formik.resetForm(); 
    setIsEdit(false); 
    setEditId(null);
    setModeData(null);
    formik.values.mode='';   
    formik.values.task_type=''; 
    formik.setFieldValue("mode", '');
    formik.resetForm({
      values: {
        mode: "",
        task_type: "",
      },
    });
  };  

  // const columns = [    
  //   {
  //     Header: "Actions",
  //     headerClassName: 'text-center',
  //     className: 'text-center',
  //     Cell: (cellProps) => {
  //       const { b_active, task_type_id} = cellProps.row.original;
  //       const isActive = b_active === 1; // Status 1 = Active
  //       return (
  //         <div className="text-center">
  //             <Link to="#" className="me-2" style={{ color: isActive ? "green" : "red" }} onClick={() => handleToggleStatus(task_type_id,isActive)}>
  //               <i className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`} id={`status-tooltip-${cellProps.row.id}`}/>
  //               <UncontrolledTooltip placement="top" target={`status-tooltip-${cellProps.row.id}`}>
  //                   {isActive ? "Mark Inactive" : "Mark Active"}
  //               </UncontrolledTooltip>
  //             </Link>
  //             <Link to="#" className="text-success ml-3" onClick={() => handleEdit(cellProps.row.original)}>
  //               <i className="bx bxs-edit font-size-18" id="edittooltip" />
  //               <UncontrolledTooltip placement="top" target="edittooltip">
  //                   Edit
  //               </UncontrolledTooltip>
  //             </Link>
  //         </div>
  //       );
  //     },
  //   },
  //   { Header: "S.No", Cell: ({ row }) => taskType.length - row.index, className: "serial-no text-center", applyHeaderClass: true, },
  //   { Header: "Project Mode", accessor: "pmode" },
  //   { Header: "Task Type", accessor: "task_type" },
  //   { Header: "Created By", accessor: "create_by" },
  //   { Header: "Created On", accessor: "createon" },    
  // ];

  const columns = [
    {
      Header: "Actions",
      headerClassName: "text-center",
      className: "text-center",
      Cell: (cellProps) => {
        const { b_active, task_type_id } = cellProps.row.original;
        const isActive = b_active === 1;

        return (
          <div className="text-center">

            {/* STATUS TOGGLE */}
            {canDelete && (
              <>
                <span
                  id={`status-${task_type_id}`}
                  className="me-2"
                  style={{ color: isActive ? "green" : "red", cursor: "pointer" }}
                  onClick={() => handleToggleStatus(task_type_id, isActive)}
                >
                  <i
                    className={`mdi ${
                      isActive ? "mdi-check-circle" : "mdi-close-circle"
                    } font-size-18`}
                  />
                </span>

                <UncontrolledTooltip
                  placement="top"
                  target={`status-${task_type_id}`}
                  delay={{ show: 300, hide: 100 }}
                >
                  {isActive ? "Mark Inactive" : "Mark Active"}
                </UncontrolledTooltip>
              </>
            )}

            {/* EDIT */}
            {canEdit && (
              <>
                <span
                  id={`edit-${task_type_id}`}
                  className="text-success ms-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleEdit(cellProps.row.original)}
                >
                  <i className="bx bxs-edit font-size-18" />
                </span>

                <UncontrolledTooltip
                  placement="top"
                  target={`edit-${task_type_id}`}
                  delay={{ show: 300, hide: 100 }}
                >
                  Edit
                </UncontrolledTooltip>
              </>
            )}

          </div>
        );
      },
    },

    { Header: "S.No", Cell: ({ row }) => taskType.length - row.index, className: "serial-no text-center", applyHeaderClass: true },
    { Header: "Project Mode", accessor: "pmode" },
    { Header: "Task Type", accessor: "task_type" },
    { Header: "Created By", accessor: "create_by" },
    { Header: "Created On", accessor: "createon" },
  ];

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Time Sheet" breadcrumbItem="Task Type" />
        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row >
                <Col md={4}>
                  <FormGroup>
                    <Label>
                      Mode <span className="text-danger">*</span>
                    </Label>
                    <CustomSelect
                      id="mode"
                      name="mode"
                      isMulti={false}
                      options={typeMode}
                      value={modeData}
                         closeMenuOnScroll={false}
                      menuPosition="absolute"
                      menuPortalTarget={null}
                      onChange={(selectedOption) => {
                          formik.setFieldValue("mode", selectedOption);
                          setModeData(selectedOption);
                        }
                      }
                      onBlur={() => formik.setFieldTouched("mode", true)}
                    />                    
                    {formik.touched.mode && formik.errors.mode && (
                      <div className="text-danger">{formik.errors.mode}</div>
                    )}
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup>
                    <Label>
                      Task Type <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="task_type"
                      maxLength={50}
                      value={formik.values.task_type}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={
                        formik.errors.task_type && formik.touched.task_type
                          ? "is-invalid"
                          : ""
                      }
                    />
                    {formik.touched.task_type && formik.errors.task_type && (
                      <div className="text-danger">{formik.errors.task_type}</div>
                    )}
                  </FormGroup>
                </Col>

                {/* <Col md="4" className="text-end col-lg-12">
                  <Button type="submit" color="primary" className="btn button-save me-2">
                    <i className="fas fa-save me-1" />{editId ? "Update" : "Save"} </Button>
                  <Button type="button" className="btn button-cancel" onClick={() => { resetFormData(); }}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>  */}

                <Col className="d-flex mob-center align-items-center justify-content-end mt-2">                
                    {canCreate && (
                      <Button type="submit" color="primary" className="btn button-save me-2">
                        <i className="fas fa-save me-1" /> {editId ? "Update" : "Save"}
                      </Button>
                    )}
                    <Button type="button" className="btn button-cancel me-2" onClick={() => { resetFormData(); }}>
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={taskType}
              isGlobalFilter={true}
              customPageSize={10}
              className="custom-header-css"
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default TaskTypeTask;
